import React from 'react'

import { getAttributeName, getAttributeNames, getAttributeRankName, hasAccessToThis } from 'services/Utilities'
import { Badge } from 'ui'
import { t } from 'translations'

const UserAttributes = ({ attributes, withBadge, hideOverflow }) => {
  if (!hasAccessToThis('attributeSee')) return t('components.MISSING_PERMISSIONS')

  if (withBadge)
    return attributes.map(({ attributeId, rank }) => (
      <Badge key={attributeId} variant="secondary" className=" mr-1">{`${getAttributeName(attributeId)} (${getAttributeRankName(attributeId, rank)})`}</Badge>
    ))
  return <>{getAttributeNames(attributes, { withRank: true, delimiter: ', ', hideOverflow })}</>
}

export default UserAttributes
